import { Inject, Injectable } from '@angular/core';
import { ENVIRONMENT } from '../../../const';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ChatMessage } from '../models/chat.model';
import { ConversationId, SessionData } from '../models/conversations.model';

@Injectable({
  providedIn: 'root'
})
export class AssistantService {

  private readonly endpoint: string;

  constructor(
    @Inject(ENVIRONMENT) protected environment: any,
    private readonly http: HttpClient
  ) {
    this.endpoint = environment.endpoint;
  }

  retrieve(message: ChatMessage): Observable<ChatMessage> {
    return this.http.post<ChatMessage>(`${this.endpoint}/assistant/retrieve`, message);
  }

  retrievePublic(message: ChatMessage): Observable<ChatMessage> {
    return this.http.post<ChatMessage>(`${this.endpoint}/assistant/public/retrieve`, message);
  }

  generate(message: ChatMessage): Observable<ChatMessage> {
    return this.http.post<ChatMessage>(`${this.endpoint}/assistant/generate`, message);
  }

  scanSession(filters?: SessionData): Observable<SessionData[]> {
    const requestParams = filters || {};
    return this.http.post<SessionData[]>(`${this.endpoint}/assistant/session`, requestParams);
  }

  scanSessionById(convoId: ConversationId): Observable<SessionData> {
    return this.http.get<SessionData>(`${this.endpoint}/assistant/session/${convoId.id}`);
  }

  sendFeedback(sessionId: string, stars: number, message: string): Observable<unknown> {
    return this.http.put(`${this.endpoint}/assistant/public/session`, {
      sessionId,
      feedback: stars,
      note: message,
    });
  }
}
